<template>
<div class="card">
    <div class="card-header">Background Check</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="13"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="13" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.backgroundRequestDate" 
                            :v="$v.request.backgroundRequestDate"
                            label="Background Check Request Date"
                            slug="request-date"
                            :required="$v.request.backgroundRequestDate.$params.required ? true : false"/> 
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.backgroundCompleteDate" 
                            :v="$v.request.backgroundCompleteDate"
                            label="Background Check Complete Date"
                            slug="complete-date"
                            :required="$v.request.backgroundCompleteDate.$params.required ? true : false"/> 
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.effectiveStartDate" 
                            :v="$v.request.effectiveStartDate"
                            label="Effective Start Date"
                            slug="start-date"
                            :required="$v.request.effectiveStartDate.$params.required ? true : false"/> 
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.backgroundCheckComments"
                        :v="$v.request.backgroundCheckComments" 
                        slug="postingComments"
                        label="Internal Comments"
                        :required="$v.comments.$params.required"/>
                </b-col>
            </b-row>
            
            <div>
            <b-button type="submit" variant="primary">Complete Background Check</b-button>
              <b-button type="button" variant="outline-primary" @click="showModal">
                Offer to a different candidate</b-button>
            <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
            <b-button type="button" variant="outline-primary" @click="repost">Repost Position</b-button>
            </div>
        </b-form>
    </div>
    <b-modal id="modal-offer-different" hide-header hide-footer @hidden="close">
    <h2>Offer to a different candidate</h2>
    <hr/>
    <form ref="form" @submit.prevent="onReturnToPriorLifecycle()">
      <BaseParagraphInput v-model="offerDifferentCandidateComment"
                          :v="$v.offerDifferentCandidateComment"
                          slug="assignmentComments"
                          :required="$v.offerDifferentCandidateComment.$params.required ? true : false"
                          label="Reason for offering to different candidate"/>
      <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
      <b-button type="submit" variant="primary" :disabled="$v.offerDifferentCandidateComment.$invalid">Submit</b-button>
    </form>
  </b-modal>
</div>

</template>

<script>
import axios from "axios"
import {required, email, minLength, maxLength, numeric, requiredUnless, requiredIf} from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"

export default {
    components: {LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return {
            saveOnly: false,
            checklistComplete: false,
            comments: '',
            offerDifferentCandidateComment: null,
            isOfferDifferentCandidate: false,
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            }, 
        }
    },
     validations: {
         checklistComplete: { checked: value => value === true },
         comments: { required: false, maxLength: maxLength(4000) },
         offerDifferentCandidateComment:{
           required: requiredIf(function() {
             return this.isOfferDifferentCandidate
           }) , maxLength: maxLength(4000)
         },
         request: { 
            backgroundCheckComments: { required: false, maxLength: maxLength(4000) },
            effectiveStartDate: { required },
            backgroundRequestDate: { required: requiredUnless(function() {
                        return _.includes(['03','04','05','06','07','12'], this.request.requestTypeValue.code)
                    }), },
            backgroundCompleteDate: { required: requiredUnless(function() {
                        return _.includes(['03','04','05','06','07','12'], this.request.requestTypeValue.code)
                    }), },   
        }
     },
    computed: {        
    },
    created() {
    },
            
    mounted: function() {
        this.autosave()
    },
    
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },
        
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },
        showModal(){
          this.$bvModal.show('modal-offer-different');
          this.isOfferDifferentCandidate = true;
        },
        close(){
          this.$bvModal.hide('modal-offer-different')
          this.isOfferDifferentCandidate = false;
        },
        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },        
        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.request.backgroundCheckComments, 
                backgroundRequestDate: this.request.backgroundRequestDate,
                backgroundCompleteDate: this.request.backgroundCompleteDate,
                effectiveStartDate: this.request.effectiveStartDate,
                nextLifecycle: '15',
                advanceNextLifecycle: !this.saveOnly,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/background`, payload)
                  .then(response => { 
                   this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })         
        },
        onReturnToPriorLifecycle() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '11',
                comment: this.offerDifferentCandidateComment
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                  .then(response => { 
                    this.showRootToast("Offer Submitted", 
                        "The background check phase has been submitted.", "success")
                     this.$router.push('/home')
                  })                  
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        repost() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '07'
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    this.$router.push('/home') 
                }) 
        },
    }   
}
</script>